import Vue from "vue"
import { filterOptionList, FilterOptionEnum } from "./filter-option-enum"
import { WORKFLOW_GROUP } from "@/model/enum/role-enum"

const filterOption = Vue.extend({
    computed: {
        parcelOptionList() {
        let lov = filterOptionList
        lov = lov.map(entry => {
                let ret = {
                    label: this.$t(entry.label),
                    value: entry.value
                }

                if (entry.permissions && !this.$store.getters.employeeHasRequiredRole(WORKFLOW_GROUP)) {
                    ret = null
                }

                return ret
            }).filter(Boolean) as FilterOptionEnum[]

        return lov
        }
    }
})

export default filterOption
